import { fetchLangstonSuggestionsService } from "./SearchMenu.services";

export const fetchSuggestions = async ({
  fragment = "",
}: IFetchSuggestions) => {
  const data = await fetchLangstonSuggestionsService(fragment);
  return (data?.results as string[]) ?? [];
};

interface IFetchSuggestions {
  fragment?: string;
}
